import React, { useState } from 'react'
import FAQItem from './FAQItem'

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number>()

  const faqData = [
    {
      id: 1,
      question: 'Is BritFiler HMRC-recognized?',
      answer:
        'Yes, BritFiler is recognized by HMRC and fully integrated with their systems. We use secure APIs to submit filings directly to HMRC and Companies House, ensuring compliance with all UK regulations.',
    },
    {
      id: 2,
      question: 'Who needs to file a Self Assessment tax return?',
      answer:
        'You need to file a Self Assessment tax return if you are self-employed, a sole trader, a company director, have income from property, investments, or other sources that aren\'t taxed at source, or have been asked to by HMRC. BritFiler helps you determine if you need to file and guides you through the entire process.',
    },
    {
      id: 3,
      question: 'Can I file my Self Assessment through BritFiler?',
      answer:
        'Yes! BritFiler is fully integrated with HMRC and allows you to file your Self Assessment (SA100) directly through our platform. Our step-by-step wizard makes it easy, even if you\'ve never filed before.',
    },
    {
      id: 4,
      question: 'When is the Self Assessment deadline?',
      answer:
        'The deadline for online Self Assessment submissions is January 31st each year. For paper returns, the deadline is October 31st. BritFiler automatically tracks your deadlines and sends reminders to help you stay compliant.',
    },
    {
      id: 5,
      question: 'What is a CT600?',
      answer:
        'A CT600 is the Corporation Tax return form that all UK limited companies must file with HMRC. BritFiler can help you file both your Corporation Tax (CT600) and company accounts to Companies House in one seamless process.',
    },
    {
      id: 6,
      question: 'Can BritFiler file both my Corporation Tax and Company Accounts?',
      answer:
        'Absolutely! BritFiler supports filing CT600 with HMRC and your annual accounts with Companies House. You can file them together or separately, depending on your needs.',
    },
    {
      id: 7,
      question: 'When is the Corporation Tax due?',
      answer:
        'Corporation Tax payment is due 9 months and 1 day after your company\'s accounting period ends. The CT600 filing deadline is 12 months after the end of your accounting period. BritFiler tracks these dates and reminds you well in advance.',
    },
    {
      id: 8,
      question: 'What is a Confirmation Statement?',
      answer:
        'A Confirmation Statement is a filing that all UK companies must submit to Companies House at least once every 12 months. It confirms your company\'s information is up to date. BritFiler reminds you before it\'s due and helps you submit it easily.',
    },
  ]

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index)
  }

  return (
    <section className='pt-20 px-4 sm:px-6 lg:px-20 bg-white'>
      <div className='w-full mx-auto'>
        {/* Header */}
        <div className='text-center mb-8'>
          <h2 className='text-4xl font-bold text-gray-900 mb-4'>
            Frequently Asked Questions
          </h2>
          <p className='text-lg text-gray-600 mb-4'>
            Find answers to common questions about Self Assessment, Corporation Tax, Confirmation Statements, and more.
          </p>
          {/* <button
            onClick={() => navigate('/help-center')}
            className='bg-[#001B38] text-white px-8 py-3 rounded-[14px] font-medium hover:bg-gray-800 transition-colors'
          >
            Help center
          </button> */}
        </div>

        {/* FAQ Accordion */}
        <div className='bg-[#EEF0F2] rounded-[32px] overflow-hidden'>
          {faqData.map((faq, index) => (
            <FAQItem
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQSection
